// Franja fija e independiente de cualquier header sticky/fixed de la página.
// position:sticky en el WebView de Android/Chromium puede "perder" el header
// durante scroll rápido (bug conocido), dejando que el contenido se dibuje
// detrás del reloj/señal/batería. Esto no depende de eso: siempre pinta esa
// franja exacta, sin importar qué esté pasando en la página debajo.
// En web normal env(safe-area-inset-top) es 0px, así que esto no se ve ni ocupa nada.
export default function StatusBarScrim() {
  return (
    <div
      aria-hidden="true"
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        height: "env(safe-area-inset-top, 0px)",
        background: "#111827",
        zIndex: 9999,
        pointerEvents: "none",
      }}
    />
  );
}
